import React, { Component } from 'react';
import { Context } from 'context/context';

import DynoGraph from "./DynoGraph";

import styles from 'dashboard/projects/project/Project.module.scss';

class BaseWizard extends Component {
    static contextType = Context;

    state = {
        loading: false,
        stockMax: null,
        stageOneMax: null,
    };

    async componentDidMount() {
        this.setState({
            loading: true
        });
        let dyno;
        let wizardChange = null;

        if(this.props.wizard.dynoHash){
            try {
                const data = await this.context.getWizardDynoData(this.props.wizard.dynoHash);
                // The shape is read inside the try too: an empty dyno array or a missing hp list renders the tile without its graph.
                const stockMax = Math.max(...data.dyno[0].stock.hp);
                const stageOneMax = Math.max(...data.dyno[0].stage1.hp);
                if(!Number.isFinite(stockMax) || !Number.isFinite(stageOneMax)) throw new Error("unexpected dyno shape");
                wizardChange = stageOneMax - stockMax;
                dyno = data;
            } catch(error) {
                // the provider has toasted a failed fetch; the tile renders without its dyno graph
            }
        }

        this.setState({
            dyno,
            loading: false,
            wizardChange
        })
    }

    render() {
        return (
            !this.state.loading ?
                <div onClick={this.props.applying ? undefined : this.props.selectBase.bind(this, this.props.wizard.id)} className={`highlightTertiary bgTertiary ${this.props.base === this.props.wizard.id ? styles.selected : null}`}>

                    <div>
                        <div>
                            {this.props.base === this.props.wizard.id ?
                                this.props.wizard.purchased ?
                                    <img src={require(`images/icons/${this.context.lightTheme ? "radio-light" : "radio-dark"}.svg`)} alt="Already paid" />
                                    :
                                    <img src={require(`images/icons/${this.context.lightTheme ? "addon-light" : "addon-dark"}.svg`)} alt="Selected" />
                            :
                                <img src={require(`images/icons/${this.context.lightTheme ? "unselected-grey" : "unselected"}.svg`)} alt="Not Selected" />
                            }
                            <p>{this.props.wizard.name.toLowerCase()} Base Map</p>
                        </div>

                        <div className={styles.wizardDetails}>
                            {this.state.wizardChange && <p className={styles.increase}>+{this.state.wizardChange}<span>HP</span></p>}
                        </div>
                    </div>

                    {this.state.dyno && this.props.wizard.dyno &&
                        <div className={styles.dyno}>
                            <DynoGraph {...this.state.dyno} />
                        </div>
                    }

                </div>
            :
                null
        )
    }
}

export default BaseWizard;
